var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { repairService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
var KosekiDataService = /** @class */ (function () {
    function KosekiDataService() {
    }
    /**
     * 户籍资料查询
     */
    KosekiDataService.prototype.search = function (data, page, sort, loading) {
        return this.netService.send({
            server: repairService.kosekiDataController.search,
            data: data,
            page: page,
            sort: sort,
            loading: loading
        });
    };
    /**
     * 户籍资料创建
     */
    KosekiDataService.prototype.insert = function (data, loading) {
        return this.netService.send({
            server: repairService.kosekiDataController.insert,
            data: data,
            loading: loading
        });
    };
    /**
     * 删除户籍资料
     */
    KosekiDataService.prototype.delete = function (data, loading) {
        return this.netService.send({
            server: repairService.kosekiDataController.delete,
            data: data,
            loading: loading
        });
    };
    /**
     * 修改户籍资料
     */
    KosekiDataService.prototype.update = function (data, loading) {
        return this.netService.send({
            server: repairService.kosekiDataController.update,
            data: data,
            loading: loading
        });
    };
    /**
     * 按照elasticSearch的文档名称搜索导入批次结果
     */
    KosekiDataService.prototype.searchGroupResult = function (docName, loading) {
        return this.netService.send({
            server: repairService.kosekiDataController.searchGroupResult,
            data: {
                docName: docName
            },
            loading: loading
        });
    };
    /**
     * 按导入批次删除户籍资料
     */
    KosekiDataService.prototype.deleteByBatch = function (batchNumber, loading) {
        return this.netService.send({
            server: repairService.kosekiDataController.deleteByBatch,
            data: {
                batchNumber: batchNumber
            },
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], KosekiDataService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], KosekiDataService.prototype, "search", null);
    return KosekiDataService;
}());
export { KosekiDataService };
